export default __webpack_public_path__ + "static/media/promo_01.bae85e1d.jpg";